angular.module('eatself').component('stuartPickupInfo',{
	bindings: {
		job: '<',
	},
	controllerAs: 'vm',
	template: `
	<span ng-if="!vm.job.deliveries[0].picked_at">
		Retrait prévu à: {{vm.job.pickup_at|stripTimezone|date:'HH:mm'}}
		<span ng-if="vm.job === false" class="text-danger">Job invalide</span>
		<i class="loading" ng-show="!vm.job && vm.job !== false"></i>
	</span>
	<span ng-if="vm.job.deliveries[0].picked_at">
		Retrait effectué à: {{vm.job.deliveries[0].picked_at|stripTimezone|date:'HH:mm'}}
	</span>
`
})